import { Injectable } from "@angular/core";
import { Ability, RawRule } from "@casl/ability";
import { Role } from "src/app/interfaces";
import { LogClass } from "src/app/logger";
import { AbstractAuthorizationService } from "./abstractAuthorization.service";

@Injectable({
  providedIn: "root"
})
@LogClass({ source: "AuthorizationService" })
export class AuthorizationService implements AbstractAuthorizationService {
  constructor(private ability: Ability) {
    this.ability.update([]);
  }

  private updateCasl(rules: RawRule[]): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.ability.update(<any>rules);
  }

  public update(roles: Role[]): void {
    const rawRules: RawRule[] = [];
    for (let roleIdx = 0; roleIdx < roles.length; roleIdx++) {
      const role = roles[roleIdx];
      for (
        let abilityIdx = 0;
        abilityIdx < role.abilities.length;
        abilityIdx++
      ) {
        const ability = role.abilities[abilityIdx];
        rawRules.push(ability);
      }
    }
    this.updateCasl(rawRules);
  }

  public isAdmin(roles: Role[]): boolean {
    return roles.filter((x) => x.name.toLowerCase() === "admin").length > 0;
  }

  public isServiceDesk(roles: Role[]): boolean {
    return (
      roles.filter((x) => x.name.toLowerCase() === "servicedesk").length > 0 ||
      this.isAdmin(roles)
    );
  }

  public isUnknown(roles: Role[]): boolean {
    return roles.filter((x) => x.name.toLowerCase() === "unknown").length > 0;
  }
}
